import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessLight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 73, height: 72, viewBox: "0 0 73 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M23 36L32 45L50 27M66.5 36C66.5 52.5685 53.0685 66 36.5 66C19.9315 66 6.5 52.5685 6.5 36C6.5 19.4315 19.9315 6 36.5 6C53.0685 6 66.5 19.4315 66.5 36Z", stroke: "#0FD076", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSuccessLight);
export { ForwardRef as ReactComponent };
